import '.dl{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.dm{padding-left:1.5rem;}.ssr-plugin'
import '.dn{margin:1rem 0;}.ssr-plugin'
import '.do{color:var(--gray-700);}.ssr-plugin'
import '.dp{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="dl dm dn do dp"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
